import {
  IonContent,
  IonList,
  IonMenu,
  IonRouterLink,
  IonAvatar,
} from "@ionic/react";
import React, { useEffect, useLayoutEffect, useState, useContext } from "react";
import { menuController } from "@ionic/core/components";
import "./Menu.scss";
import logoLight from "../../../assets/images/logo/nserix-primary.svg";
import logoDark from "../../../assets/images/logo/nserix-dark.svg";
import classNames from "classnames/bind";
import {
  BasicmenuConstants,
  ccPlusmenuConstants,
  menuConstants,
  emsMenuConstants,
} from "../../../constants/MenuObjects";
import {
  StatusBoardList,
  StatusBoardListReq,
} from "./Menu.model";
import { menuService } from "./Menu.service";
import { utilService } from "../../../services/utilService";
import _, { indexOf } from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import { CONSTANTS } from "../../../constants/callcentral.constants";
import { StorageService } from "../../../services/storage.service";
import { dataTransferService } from "../../../services/dataTransferService";

import { useHistory, useLocation } from "react-router-dom";
import { loggedInUserService } from "../../../services/loggedInUser.service";
import {MenuContext} from "../../../router/AppLayout/AppLayout"
import { useTranslation } from "react-i18next";

interface MenuProps {
  isCollapsed?: boolean;
}

const Menu: React.FC<MenuProps> = ({ isCollapsed = false }) => {
  const { t } = useTranslation(["menu", "auth"]);
  var [menuList, setMenuList]: any = useState([]);
  var [statusBoardList, setStatusBoardList]: any = useState([]);
  var [phaseStatusDetails, setPhaseStatusDetails]: any = useState([]);
  var [isEMTUser, checkEMTUser]: any = useState(false);

  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [disableInfiniteScroll, setDisableInfiniteScroll] =
    useState<boolean>(false);
  const [statusBoardIndex, setStatusBoardIndex]: any = useState();
  // statusBoardIndex only tracks *whether the list has ever loaded* -- it
  // never resets, so without a separate flag the status board sub-list
  // stayed expanded forever after the first time it was opened, even after
  // navigating to an unrelated menu item.
  const [isStatusBoardExpanded, setIsStatusBoardExpanded] = useState(false);

  const [rolePermissions, setRolePermissions] = useState<any>(Object);

  const { menuListGlobal, setMenuListGlobal } = useContext<any>(MenuContext);

  const [OnMenuList,setOnMenuList] = useState<any>([
      {
        menuId: 1,
        menuName: "Home",
        menuIcon: "icon-home",
        menuCode: "HOME",
        isMenuSelected: false,
        link: "/client/home",
        disabled: false
      },
      {
        menuId: 3,
        menuName: "Messages",
        menuIcon: "icon-chat_bubble",
        menuCode: "Chat",
        isMenuSelected: false,
        link: "/client/messages",
        disabled: false
    },

     {
        menuId: 4,
        menuName: "Membership Plan",
        menuIcon: "icon-status_board",
        menuCode: "Membership",
        isMenuSelected: false,
        link: "/client/membership",
        disabled: false
    },
    {
      menuId: 99,
      menuName: "Settings",
      menuIcon: "icon-settings",
      menuCode: "Settings",
      isMenuSelected: false,
      link: "/client/menu-settings",
      disabled: false
    }
  ])
  let history = useHistory();
  const location = useLocation();

  const [isOnUSer,setIsOnUSer] = useState(false)

  // Close the status board sub-list whenever navigation lands somewhere
  // other than a status board page (back/forward nav, direct link, etc.),
  // and keep it open when landing directly on one (e.g. refresh/deep link).
  useEffect(() => {
    setIsStatusBoardExpanded(location.pathname.includes("/client/status-board/"));
  }, [location.pathname]);

  // document.body's class is the source of truth the app's theme toggle
  // writes to (see Header.tsx/Settings.tsx/AppLayout.tsx) -- read it directly
  // and watch it for live updates.
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark-theme")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark-theme"));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setIsOnUSer(data?.userData?.roleBasedPermission?.isOnUser);
      if (data?.userData) {
        setUserData(data.userData);
      }
    });
  }, []);

  useEffect(() => {
    getPhaseStatusDetails();
    getLoggedInUserData();
    document.addEventListener("click", handleClickOutside, true);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);

  useEffect(() => {
    if (rolePermissions && !_.isEmpty(rolePermissions)) {
      SetMenuListDetails();
    }
  }, [phaseStatusDetails]);

  useEffect(() => {
    if (statusBoardList && statusBoardList.length) {
      addStatusBoardListToMenuList();
    }
  }, [statusBoardList]);

  const getLoggedInUserData = () => {
    loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data.userData);
      checkEMTUser(isEmtUser);
    });
  };

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const getPhaseStatusDetails = async () => {
    const params = "";
    const respPhaseDetailsResult: any = await menuService.getPhaseDetails(
      params
    );
    if (respPhaseDetailsResult.isSuccess && respPhaseDetailsResult.result) {
      setPhaseStatusDetails(respPhaseDetailsResult.result?.[0]);
    } else {
      menuService.handleErrorResponse();
    }
  };

  const handleClickOutside = async (event: any) => {
    // ion-menu-button already toggles the menu itself on click -- closing
    // it again here too raced with that and reopened it immediately, so a
    // second tap on the hamburger never actually closed the menu.
    if (event.target?.closest && event.target.closest("ion-menu-button")) {
      return;
    }
    //check for sidemenu status( open/ close )
    const isSideMenuOpen = await menuController.isOpen();
    if (isSideMenuOpen) {
      menuController.toggle();
    }
  };

  useLayoutEffect(() => {
    let sub = dataTransferService.getUpdateBtnClickAction.subscribe(
      (data: any) => {
        if (data === true) {
          getPhaseStatusDetails();
          const rolePermissionData =
            rolePermissionsService.getRolePermissionsDetails();
          setRolePermissions(rolePermissionData);
          history.push({
            pathname: "/client/home",
          });
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const addStatusBoardListToMenuList = () => {
    var initialMenuList = _.cloneDeep(menuList);
    let DataListArray = statusBoardList.map((object: StatusBoardList) => {
      return {
        id: object.id,
        name: object.name,
        link: `/client/status-board/${object.id}`,
      };
    });
    const statusBoardObject = _.find(initialMenuList, {
      menuId: CONSTANTS.MENU_LIST_ITEMS.STATUS_BOARD,
    });
    setStatusBoardIndex(indexOf(initialMenuList, statusBoardObject));
    initialMenuList[
      indexOf(initialMenuList, statusBoardObject)
    ].statusBoardSubList = DataListArray;
    setMenuList(...[initialMenuList]);
  };

  const SetMenuListDetails = () => {
    var initialMenuList = setPhaseStatusBasedInitialMenu();

    if (!rolePermissions.myPatients) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.MENU_LIST_ITEMS.MY_PATIENTS,
      });
    }
    if (!rolePermissions.nurseManagement) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.MENU_LIST_ITEMS.NURSE_MANAGEMENT,
      });
    }
    if (!rolePermissions.startACase) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.MENU_LIST_ITEMS.CASE_HISTORY,
      });
    }

    if (isEMTUser) {
      initialMenuList = emsMenuConstants;
    }

    if (
      !rolePermissions.statusBoard ||
      utilService.getScreenSize() === "small"
    ) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.MENU_LIST_ITEMS.STATUS_BOARD,
      });
    }
    if (!rolePermissions.unassignShift) {
      _.remove(initialMenuList, {
        menuId: CONSTANTS.MENU_LIST_ITEMS.UNASSIGNED_SHIFT,
      });
    }
    setMenuList(initialMenuList);
    setMenuListGlobal(initialMenuList)
  };

  const setActiveMenu = (item: any) => {
    let site_url_part = "/client/sites";
    let message_url_part = "/client/messages"; 
    let teams = "/client/teams";
    if (isEMTUser) {
      return true;
    }

    switch (item.link) {
      case window.location.pathname:
          return true;
          break;
      case site_url_part:
          return checkSiteUrlPath();
          break;  
      case message_url_part:
          return checkMessageUrlPath();
          break;    
      case teams:
          return checkTeamsUrlPath();
          break;        
    }


  };

  const checkMessageUrlPath = () => {
    let path = window.location.pathname;
    let url_part = path.split("/");

    if (url_part[2] === "usermessages") {
      return true;
    } else if (url_part[2] === "file-share" && url_part[3] !== "addTeammates") {
      return true;
    }
  };

  const checkTeamsUrlPath = () => {
    let path = window.location.pathname;
    let url_part = path.split("/");

    if (url_part[3] === "addTeammates") {
      return true;
    } 
  };

  const checkSiteUrlPath = () => {
    let path = window.location.pathname;
    let url_part = path.split("/");

    if (url_part[3] === "beds") {
      return true;
    } else if (url_part[3] === "units") {
      return true;
    }
  };

  const setMenuActive = (item: any) => {
    if(item.link !== window.location.pathname){
      dataTransferService.transferBtnClickAction(item);
      if (item.link === window.location.pathname) {
        window.location.reload();
      }
      if (item.menuName === "Status Board") {
        getStatusBoardListDetails();
        setIsStatusBoardExpanded(true);
      } else {
        setIsStatusBoardExpanded(false);
      }
      menuList.map((menu: any) => {
        var menuObj = Object.assign({}, menu);
        // item.menuId === menu.menuId ? {...menuObj, isMenuSelected:true} : menuObj.active = false;
        menuObj.isMenuSelected = false;
  
        return menuObj;
      });
      let array2 = menuList.map((a: any) => {
        return { ...a };
      });
  
      menuList
        .map((a: any) => {
          return { ...a };
        })
        .find((b: any) => b.id === item.id).isMenuSelected = true;
      // menuList[menuList.findIndex((obj => obj.id == 1))].active = true;
    }
  
  };

  const getStatusBoardListDetails = async () => {
    const params: StatusBoardListReq = getStatusBoardListParams();
    const respStatusBoardListResult: any = await menuService.getStatusBoardList(
      params
    );
    if (
      respStatusBoardListResult.isSuccess &&
      respStatusBoardListResult.result
    ) {
      if (pageNo === 1) {
        setStatusBoardList(respStatusBoardListResult.result.data);
      } else {
        setStatusBoardList([
          ...statusBoardList,
          ...respStatusBoardListResult.result.data,
        ]);
      }
      setPageNo(pageNo + 1);
      if (!respStatusBoardListResult.result.next) {
        setDisableInfiniteScroll(true);
      }
    } else {
      menuService.handleErrorResponse(respStatusBoardListResult?.message);
    }
  };

  const getStatusBoardListParams = () => {
    return {
      page: pageNo,
      reg_code: utilService.getNetwork(),
    };
  };
  // store the current selected statusBoard Id
  const onclickSBUnit = (item: any) => {
    const local_keys = {
      currentStatusBoardId: item.id,
    };
    StorageService.setStorageItem(localStorage, local_keys);
  };

  const setPhaseStatusBasedInitialMenu = () => {
    var initialMenuList: any = [];
    if (!_.isEmpty(phaseStatusDetails)) {
      //Enable and show all phase 3 menuItems
      if (phaseStatusDetails.phase3Status === 1) {
        initialMenuList = menuConstants;
        BasicmenuConstants.map((item: any) => {
          initialMenuList.push(item);
        });
        initialMenuList = mapPhase2Status(initialMenuList);
      }
      //hide all phase 3 menuItems
      else if (phaseStatusDetails.phase3Status === 3) {
        initialMenuList = BasicmenuConstants;
        initialMenuList = mapPhase2Status(initialMenuList);
      }
      //disable and show all phase 3 menuItems
      else if (phaseStatusDetails.phase3Status === 2) {
        initialMenuList = BasicmenuConstants;
        menuConstants.map((item: any) => {
          item.disabled = true;
          initialMenuList.push(item);
        });
        initialMenuList = mapPhase2Status(initialMenuList);
      }
    }
    // To remove duplicate menu items if ny
    var uniqueInitialMenuList = Array.from(new Set(initialMenuList));
    // To sort based on menu Id
    uniqueInitialMenuList.sort(
      (item1: any, item2: any) => item1.menuId - item2.menuId
    );
    return uniqueInitialMenuList;
  };

  const mapPhase2Status = (initialMenuList: any) => {
    if (phaseStatusDetails.phase2Status === 1) {
      ccPlusmenuConstants.map((item: any) => {
        item.disabled = false;
        initialMenuList.push(item);
      });
    } else if (phaseStatusDetails.phase2Status === 2) {
      initialMenuList = initialMenuList;
    } else if (phaseStatusDetails.phase2Status === 3) {
      ccPlusmenuConstants.map((item: any) => {
        item.disabled = true;
        initialMenuList.push(item);
      });
    }
    return initialMenuList;
  };

  const menuListValues = isOnUSer ? OnMenuList : menuList;

  const getMenuLabel = (item: any) => {
    switch (item.menuCode) {
      case "HOME":
        return t("menu:home");
      case "Call Schedule":
        return t("menu:callSchedule");
      case "Chat":
        return t("menu:messages");
      case "Site":
        return t("menu:sites");
      case "My Patients":
        return t("menu:myPatients");
      case "Teams":
        return t("menu:teams");
      case "Unassigned-shifts":
        return t("menu:unassignedShifts");
      case "Nurse Management":
        return t("menu:nurseManagement");
      case "Case History":
        return t("menu:caseHistory");
      case "Status Board":
        return t("menu:statusBoard");
      case "On Call Lookup":
        return t("menu:onCallLookUp");
      case "Membership":
        return t("menu:membership");
      case "Settings":
        return t("menu:settings", "Settings");
      default:
        return item.menuName;
    }
  };

  return (
    <IonMenu
      contentId="main"
      className={classNames({
        // Keep the side menu visible on status boards too. It was hidden here
        // (display:none), which on the web client left the full-screen board
        // with no navigation -- no way to switch boards or go back smoothly.
        "side-menu": true,
        collapsed: isCollapsed,
      })}
    >
      <IonContent>
                <div className="menu-list-container">
          <IonList lines="none" className="side-menu">
            <div className="logo-wrapper">
              <img
                className="callcentral-logo"
                src={
                  isCollapsed
                    ? "assets/icon/nserix-icon.svg"
                    : isDarkMode
                    ? logoDark
                    : logoLight
                }
                alt="Nserix"
              />
            </div>
            {!_.isEmpty(menuListValues) &&
              menuListValues.map((item: any) => {
                if (item.link) {
                  return (
                    <div
                      className={item.disabled ? "disabled-menu" : ""}
                      key={item.menuId}
                    >
                      <IonRouterLink routerLink={item.link}>
                        <div
                          className={`menu-items ${
                            setActiveMenu(item) ? "menu-active" : ""
                          }`}
                          onClick={() => {
                            setMenuActive(item);
                            menuController.toggle();
                          }}
                        >
                          <span className={item.menuIcon}></span>
                          <span className="menu-label">{getMenuLabel(item)}</span>
                        </div>
                      </IonRouterLink>
                    </div>
                  );
                } else {
                  return (
                    <div key={item.menuId}>
                      <div className={item.disabled ? "disabled-menu" : ""}>
                        <div
                          className={`menu-items ${
                            location.pathname.includes("/client/status-board/")
                              ? "menu-active"
                              : ""
                          }`}
                          onClick={() => {
                            setMenuActive(item);
                          }}
                        >
                          <span className={item.menuIcon}></span>
                          <span className="menu-label">{getMenuLabel(item)}</span>
                        </div>
                      </div>

                      {statusBoardIndex && isStatusBoardExpanded && (
                        <div className="sb-sub-menu">
                          <InfiniteScroll
                            dataLength={
                              menuList[statusBoardIndex].statusBoardSubList
                                .length
                            }
                            height={150}
                            next={() => getStatusBoardListDetails()}
                            hasMore={true}
                            loader={<div></div>}
                          >
                            {menuList[statusBoardIndex].statusBoardSubList
                              .length === 0 && (
                              // Without this the submenu was an empty box, so a
                              // user with no status boards saw the menu item do
                              // nothing at all and reported it as not clickable.
                              <div className="sb-sub-menu-items sb-sub-menu-empty">
                                {t("menu:noStatusBoards", "No status boards")}
                              </div>
                            )}
                            {menuList[statusBoardIndex].statusBoardSubList.map(
                              (item: any) => {
                                return (
                                  <div key={item.id}>
                                    <IonRouterLink routerLink={item.link}>
                                      <div
                                        className="sb-sub-menu-items"
                                        onClick={() => onclickSBUnit(item)}
                                      >
                                        {item.name}
                                      </div>
                                    </IonRouterLink>
                                  </div>
                                );
                              }
                            )}
                          </InfiniteScroll>
                        </div>
                      )}
                    </div>
                  );
                }
              })}
          </IonList>
          
        </div>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
